var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.332 9V1.5H4.33203V9M13.6654 9C13.6654 9.6875 13.0654 10.25 12.332 10.25H4.33203C3.5987 10.25 2.9987 9.6875 2.9987 9V1.5C2.9987 0.8125 3.5987 0.25 4.33203 0.25H12.332C13.0654 0.25 13.6654 0.8125 13.6654 1.5M9.66537 11.5V12.75H1.66536C0.932031 12.75 0.332031 12.1875 0.332031 11.5V3.375H1.66536V11.5M9.66537 5.875H10.9987V7.75H9.66537M7.66536 2.75H8.9987V7.75H7.66536M5.66536 4H6.9987V7.75H5.66536V4Z",
    fill: "#67697D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChart);
export default __webpack_public_path__ + "static/media/bar-chart.9c5169b8d80d3bc64537bbce0bca804e.svg";
export { ForwardRef as ReactComponent };